export default {"src":"/_next/static/media/DarkLogo.c23e9aac.svg","height":97,"width":230};